import React, { FC, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { LinkButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { Input } from '@eika/input';

import gyldigEpostFormat from '../../infra/format';
import { useTranslation } from '../../translations';

export type MedlaantakerEpostFormData = {
    medlaantakerEpost: string | undefined;
};

const MedlaantakerEpostViewEdit: FC = () => {
    const { oppsummering, button, validationMessage } = useTranslation();
    const {
        register,
        control,
        trigger,
        formState: { errors },
    } = useFormContext<MedlaantakerEpostFormData>();

    const value = useWatch({ name: 'medlaantakerEpost', control });
    const [editEpost, setEditEpost] = useState<boolean>(false);

    return (
        <>
            {!editEpost && (
                <div>
                    <label className="sgw-input__input-mainlabel">{oppsummering.labelMedlaantakerEpost}</label>
                    <LinkButton
                        iconOnRightSide
                        icon={IconTypes.PENN_24}
                        data-track-id="kreditt-boliglaan-oppsummering-medlaantaker-epost"
                        data-track-linkname="endre"
                        onClick={() => setEditEpost(!editEpost)}
                    >
                        {value}
                    </LinkButton>
                </div>
            )}
            {editEpost && (
                <div className="column column-gap align-items-end">
                    <Input
                        inputMode="email"
                        label={oppsummering.labelMedlaantakerEpost}
                        className="max-width-200"
                        error={errors.medlaantakerEpost?.message}
                        {...register('medlaantakerEpost', {
                            required: `${validationMessage.requiredValue}`,
                            pattern: {
                                value: gyldigEpostFormat,
                                message: `${validationMessage.patternEpost}`,
                            },
                        })}
                    />
                    <LinkButton
                        className={errors.medlaantakerEpost?.message ? 'margin-bottom-larger' : ''}
                        data-track-id="kreditt-boliglaan-oppsummering-medlaantaker-epost"
                        data-track-linkname="oppdater"
                        onClick={async () => {
                            const result = await trigger('medlaantakerEpost');
                            if (result) {
                                setEditEpost(!editEpost);
                            }
                        }}
                    >
                        {button.lagre}
                    </LinkButton>
                </div>
            )}
        </>
    );
};

export default MedlaantakerEpostViewEdit;
